/**
 * thx-pixel-emq.js
 * Meta Pixel Event Match Quality Booster
 * The Home Xperts — Pixel ID: 689027802406683
 * Ported to "Latest Theme - 2026" (hdt theme): 2026-07-19
 *
 * Handles logged-in customer advanced matching only.
 * fbc/fbp cookie persistence runs synchronously in <head>
 * (before content_for_header) — see layout/theme.liquid.
 */
(function () {
  'use strict';

  function getCookie(name) {
    var rx = new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\^\/+])/g, '\\$1') + '=([^;]*)');
    var m = document.cookie.match(rx);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* ---------- Logged-in customer advanced matching ----------
   * window.__thxCustomer is set inline in theme.liquid via Liquid
   * only when customer is logged in — no PII in JS bundle.
   * SHA-256 hashing happens client-side via SubtleCrypto (native).
   */
  (function pushCustomerData() {
    try {
      var customer = window.__thxCustomer;
      if (!customer) return;

      window.dataLayer = window.dataLayer || [];

      function sha256(str) {
        if (!str || !crypto || !crypto.subtle) return Promise.resolve(null);
        var normalized = String(str).trim().toLowerCase();
        var encoded = new TextEncoder().encode(normalized);
        return crypto.subtle.digest('SHA-256', encoded).then(function (buf) {
          return Array.from(new Uint8Array(buf))
            .map(function (b) { return b.toString(16).padStart(2, '0'); })
            .join('');
        });
      }

      Promise.all([
        sha256(customer.email),
        sha256(customer.phone)
      ]).then(function (hashes) {
        var emHash = hashes[0] || null;
        var phHash = hashes[1] || null;
        var fbc = getCookie('_fbc') || getCookie('thx_fbc') || null;
        var fbp = getCookie('_fbp') || getCookie('thx_fbp') || null;

        window.dataLayer.push({
          event: 'thx_customer_data',
          thx_em: emHash,
          thx_ph: phHash,
          thx_external_id: customer.id || null,
          thx_fbc: fbc,
          thx_fbp: fbp
        });

        if (typeof window.fbq === 'function' && emHash) {
          var advancedMatching = { em: emHash };
          if (phHash) advancedMatching.ph = phHash;
          if (customer.id) advancedMatching.external_id = String(customer.id);
          if (fbc) advancedMatching.fbc = fbc;
          if (fbp) advancedMatching.fbp = fbp;
          window.fbq('init', '689027802406683', advancedMatching);
        }
      }).catch(function () {});
    } catch (e) {}
  })();

})();
